import { useEffect } from 'react';

export const ImageElement = props => {
	// Hooks
	useEffect(() => {
		// logger.log('ImageElement: ', props);
	}, []);

	// Render
	return (
		<span className='space-y-3'>
			<img {...props} />
			<span className='border-l-4 border-border flex-start ml-1 px-4'>
				<small className='block text-sm font-light text-foreground-body italic !font-light !mb-0'>{props.alt}</small>
			</span>
		</span>
	);
};
